/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var SpinnerIcon = createIcon("SpinnerIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0v2c4.723.469 8.531 4.277 9 9h2C23.518 5.172 18.827.482 13 0",
    fill: "#0045DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0C5.173.482.482 5.172 0 11h2c.469-4.723 4.277-8.531 9-9V0Zm0 22c-4.723-.47-8.531-4.276-9-9H0c.482 5.828 5.173 10.518 11 11v-2Zm11-9c-.469 4.724-4.277 8.53-9 9v2c5.827-.482 10.518-5.172 11-11h-2Z",
    fill: "#E8F0F9"
  })));
}, {});